/**
 * types redux constants
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// redux action IDs
export const LOAD_TYPE_DEFINITIONS          = 'LOAD_TYPE_DEFINITIONS';
